export default "__VITE_ASSET__e4a8945c__"